import * as SuperAgentCache from 'cache-service-cache-module'
import * as superAgentCachePlugin from 'superagent-cache-plugin'
import { REQUEST_CACHE_EXPIRATION_TIME } from 'common/constants'

const superAgentCache = new SuperAgentCache({
  storage: 'local',
  defaultExpiration: REQUEST_CACHE_EXPIRATION_TIME
})

export const requestCacheMiddleware = superAgentCachePlugin.call(
  {},
  superAgentCache
)
